/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ product: NonNullable<unknown> }} Discount_Rule_Delete_ConfirmInputs */

const vi_discount_rule_delete_confirm = /** @type {(inputs: Discount_Rule_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xóa quy tắc chiết khấu cho ${i?.product}?`)
};

/**

* @param {Discount_Rule_Delete_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const discount_rule_delete_confirm = /** @type {((inputs: Discount_Rule_Delete_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Discount_Rule_Delete_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_discount_rule_delete_confirm(inputs)
});